// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_55-6";
export var headerCell = "_55-2";
export var loadingStateContent = "_55-8";
export var rowWrapper = "_55-4";
export var stickyAggregationCell = "_55-b";
export var stickyAggregationRow = "_55-7";
export var stickyColumnCell = "_55-a";
export var stickyColumnHeaderCell = "_55-9";
export var table = "_55-1";
export var virtualRowWrapper = "_55-5";
export var virtualTableContainer = "_55-0";
export var white = "_55-3";